
import { useState } from 'react';
import { Email_VALIDATOR, ERRORS } from '../../constants/AppConstants';
import { useMutation, useQuery } from 'react-query';
import loginUser, { shopifyUser } from '../../services/loginService';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useHistory } from 'react-router';
import { useAppContext } from '../../appProvider/contextProvider';
import PreLoginBanner from '../../components/PreloginBanner';
import LogoContainer from '../../components/LogoContainer';
import Loader from '../../components/Loader/loader';



const Login = () => {
    const history = useHistory();
    const [email, setEmail] = useState(localStorage.getItem('email') || '');
    const [password, setPassword] = useState('');
    const [rememberMe, setRememberMe] = useState(!!localStorage.getItem('rememberMe') || false);
    const [emailError, setEmailError] = useState(null);
    const [passwordError, setPasswordError] = useState(null);
    const [formError, setFormError] = useState(null);

    const [viewPassword, setViewPassword] = useState(false);

    const { setUserDetails, isFetching, isMutating, setPlanDetails, setIsShopify } = useAppContext();
    
    const shp_key = localStorage.getItem('shp_key');   

    useQuery(['shopifyLogin', shp_key], () => shopifyUser(shp_key), {
        enabled: !!shp_key,
        useErrorBoundary: false,
        onSuccess: ((response) => {
            if(response.errors) {
                handelError(response.errors)
            } else {
                localStorage.removeItem('shp_key');
                handelSuccess(response);
            }
        }),
    });

    

    const signIn = useMutation((event) => {
        event.preventDefault();
        return loginUser({email, password})
    }, 
     {
        onSuccess: ((response) => {
            if(response.errors) {
                handelError(response.errors)
            } else {
                localStorage.removeItem('shp_key');
                handelSuccess(response);
            }
            
        }),
        onError: ((error) => {
            toast.error('Something went wrong');
        })
    });

    const handelError = (error) => {
        if(error.incorrect_credentials) {
            toast.error(ERRORS[error.incorrect_credentials[0]], {
                autoClose: 5000,
                position: 'bottom-right'
            });
        }
        if(error.email) {
            toast.error(ERRORS[error.email[0]],  {
                autoClose: 5000,
                position: 'bottom-right'
            });
        }
        if(error.account_locked) {
            toast.error(ERRORS[error.account_locked],  {
                autoClose: 5000,
                position: 'bottom-right'
            });
        }
        if(error.current_no_of_attempts && error.maximum_no_of_attempts) {
            toast.info(`${error.current_no_of_attempts[0]} out of ${error.maximum_no_of_attempts} login attempts done`,  {
                autoClose: 5000,
                position: 'bottom-right'
            });
        }
        if(error.permission_denied) {
            toast.error(ERRORS.token_expired,  {
                autoClose: 5000,
position: 'bottom-right'
            });
        }
    }

    const handelSuccess = (response) => {
        localStorage.setItem('token', response?.token);
        localStorage.setItem('user_id', response?.user?.id);
        setFormError(null);
        if(rememberMe) {
            localStorage.setItem('email', email);
            localStorage.setItem('rememberMe', true);
        } else {
            localStorage.removeItem('email');
            localStorage.removeItem('rememberMe');
        }
        setUserDetails(response.user);
        setPlanDetails(response.subscription);
        setIsShopify(!!response?.owner?.has_shopify);
        history.push('/dashboard');
    }

    const handelEmailValidation = (value) => {
        if(value.length <= 0 ) {
            setEmailError(ERRORS.EMAIL_REQUIRED);
        }
        else if(!value.match(Email_VALIDATOR)) {
            setEmailError(ERRORS.IN_VALID_EMAIL);
        } else {
            setEmailError(null);
        }
        setEmail(value)
    }

    const handelPasswordValidation = (value) => {
        if(value.trim().length <= 0 ) {
            setPasswordError(ERRORS.PASSWORD_REQUIRED);
        } else if(value.length >= 30) {
            setPasswordError(ERRORS.PASSWORD_MAX_LENGTH);
        } else {
            setPasswordError(null);
        }
        setPassword(value)
    }

    const isLoginDisabled = () => {
        return email.length <= 0 || password.trim().length <= 0 || emailError || passwordError
    }

    const navigateTo = (event, route) => {
        event.preventDefault();
        history.push(route);
    }

    return <>
        <div className={!!(isMutating || isFetching) ? 'row no-gutters page-container loader full-height p-0':  'row no-gutters full-height'}>
            {!!(isMutating || isFetching) && <Loader />}
            <div className="col col-12 col-lg-6">
            <form onSubmit={signIn.mutate} className="login-container d-flex flex-column justify-content-center full-height">                
                <LogoContainer />          
                <h3 className="text-primary mb-2">Login</h3>
                <p className="text-light mb-4">Send Notifications and Track your engagement!</p>
                {formError && <span className="error-message">{formError}</span>}
                <div className="form-group">                   
                    <label className="form-label text-dark regular">Email <span className="">*</span></label>
                    <div className="input-addon input-group-left">
                        <i className="icon icon-mail"></i>
                        <input 
                            type="text"
                            value={email} 
                            onChange={({target}) => handelEmailValidation(target.value)}
                            placeholder="Enter Your Email" 
                            className="form-control"
                        />                        
                    </div>                    
                    {emailError && <span className="error-message">{emailError}</span>}
                </div>
                <div className="form-group">
                    <label className="form-label text-dark regular">Password <span className="">*</span></label>
                    <div className="input-addon input-group-left">
                        <i className="icon icon-security"></i>
                        <input 
                            type={viewPassword ? 'text': 'password'}
                            value={password}
                            onChange={({target}) => handelPasswordValidation(target.value)}
                            placeholder="Enter Your Password" 
                            className="form-control"
                        />
                        {/* conditionally chnage the icon class to icon-eye to icon-password-mask */}
                        <button type="button" className="btn btn-neutral">
                            <i 
                                className={viewPassword ? 'icon icon-password-mask' : 'icon icon-eye'}
                                onClick={() => setViewPassword(!viewPassword)}
                            ></i></button>
                    </div>
                    {passwordError && <span className="error-message">{passwordError}</span>}
                </div>
                <div className="d-flex justify-content-between align-items-center">
                    <div className="form-check">
                        <input 
                            type="checkbox" 
                            className="form-check-input" 
                            id="exampleCheck1" 
                            checked={rememberMe}
                            onChange={() => setRememberMe(!rememberMe)}
                        />
                        <label className="form-check-label ml-2 mb-0" htmlFor="exampleCheck1">Remember me</label>
                    </div>
                    <a href="" className="primary-link" onClick={(e) => navigateTo(e, '/forgotPassword')} >Forgot Password?</a>
                </div>
                <button type="submit" className="btn tbn-block btn-primary my-3" disabled={isLoginDisabled()} onClick={signIn.mutate} >Login</button>                
                <p className="privacy-text text-center" >Not registered yet? <a href="" className="primary-link" onClick={(e) => navigateTo(e, '/sign-up')}>Create Your Account</a></p>

            </form>
            </div>
            <PreLoginBanner />
        </div>
        
    </>
}
export default Login;